<template>
  <div>
    <h3 class="mr-2" style="display:inline" v-for="tag in tags" :key="tag.id">
      <!-- TODO: add link to expertise area -->
      <b-badge class="ml-1" variant="primary">
          {{tag.name}}
      </b-badge>
    </h3>
    <a v-if="canEdit" href="" @click.prevent="openDialog()">Add/Edit Tags</a>

    <div v-if="show">
      <b-form inline class="mb-2">
        <b-input-group>
          <vue-tags-input
          v-model="tag"
          :tags="editableTags"
          @tags-changed="update"
          :autocomplete-items="autocompleteItems"
          :add-only-from-autocomplete="true"
        />
        </b-input-group>

        <b-button class="mx-2" variant="primary" @click="save()">Save</b-button>
        <a href="" @click.prevent="closeDialog()">Cancel</a>

        
      </b-form>
      <div>Not finding the tags you're looking for? Request new tags to be added: <a href="mailto:CHSTranslationalTeams@asu.edu">CHSTranslationalTeams@asu.edu</a></div>
    </div>
  </div>  
</template>
<script>
import { mapState } from "vuex";
import VueTagsInput from "@johmun/vue-tags-input";
import * as _ from "lodash";
import tagsApi from "../api/objectTags";

export default {
  data() {
    return {
      show: false,
      tag: "",
      internalTags: [],
      autocompleteItems: []
    };
  },

  props: {
    tags: {
      type: Array,
      required: true
    },
    id: {
      type: [String, Number],
      required: false
    },
    canEdit: {
      type: Boolean,
      required: false
    },
    app: {
      type: String,
      required: true
    },
    object: {
      type: String,
      required: true
    },
    objectId: {
      type: String,
      required: true
    }
  },

  components: {
    VueTagsInput
  },

  computed: {
    ...mapState({
      user: state => state.auth.user
    }),
    objectIdString: function() {
      return this.objectId.toString();
    },
    editableTags: function() {
      var filtered = _.filter(this.tags, tag => {
        return tag.editable == true;
      });

      var mapped = _.map(filtered, tag => {
        return {
          id: tag.id,
          app: tag.app,
          object: tag.object,
          objectId: tag.objectId,
          tagId: tag.tagId,
          editable: tag.editable,
          text: tag.name
        };
      });
      return mapped;
    },
    remappedTags: function() {
      var remapped = _.map(this.internalTags, tag => {
        return {
          id: tag.id || 0,
          app: tag.app || this.app,
          object: tag.object || this.object,
          objectId: tag.objectId || this.objectIdString,
          tagId: tag.tagId,
          editable: true
        };
      });
      return remapped;
    }
  },

  methods: {
    update(newTags) {
      this.autocompleteItems = [];
      this.internalTags = newTags;
    },
    initItems() {
      if (this.tag.length < 2) return;
      clearTimeout(this.debounce);
      this.debounce = setTimeout(() => {
        tagsApi
          .getTags(this.tag)
          .then(response => {
            this.autocompleteItems = _.map(response.data, tag => {
              return { text: tag.name, tagId: tag.id };
            });
          })
          .catch(error => console.warn(error));
      }, 600);
    },
    save() {
      tagsApi
        .createTags(
          this.remappedTags,
          this.app,
          this.object,
          this.objectIdString
        )
        .then(response => {
          this.$emit("success", response.data);
          this.closeDialog();
        })
        .catch(error => console.warn(error));
    },
    openDialog() {
      this.show = true;
    },
    closeDialog() {
      this.show = false;
    }
  },

  watch: {
    tag: "initItems",
    tags: function() {
      this.internalTags = this.editableTags;
    }
  },

  created() {
    this.internalTags = this.editableTags;
  }
};
</script>
<style scoped>
.badge-primary {
  background-color: #8c1d40;
  border-color: #70112f;
}

.badge-primary:hover {
  background-color: #a02048;
}
</style>
